module.exports = __webpack_public_path__ + "static/img/ic_video_photo.e8920b9c.png";